import { render, staticRenderFns } from "./Layout2.vue?vue&type=template&id=e03a5bec&scoped=true&"
import script from "./Layout2.vue?vue&type=script&lang=js&"
export * from "./Layout2.vue?vue&type=script&lang=js&"
import style0 from "./Layout2.vue?vue&type=style&index=0&id=e03a5bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03a5bec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
